var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rating > 0)?_c('div',{staticClass:"score",class:_vm.direction === 'row' && 'score--row'},[_c('span',{staticClass:"score__number"},[_c('span',[_vm._v(_vm._s(_vm.decimal_score))])]),_c('span',{staticClass:"score__rank",domProps:{"innerHTML":_vm._s(_vm.custom_textual_score(_vm.decimal_score))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }